<div class="p-6 general-simple-box flex flex-col gap-6">
  <div class="flex flex-col gap-y-7 w-full">
    <div class="lg:px-8 px-0 pb-4 pt-8 flex flex-col gap-4 bg-white">
      <div class="grid justify-center items-center gap-3 grid-cols-1">
        <div class="text-general-subtitle w-full">
          {{ 'users.labels.recoverPassword' | translate }}
        </div>
        <div class="w-full">
          <app-input-general
            [formControlGeneral]="username"
            [label]="'users.inputs.username'"
            [placeholder]="'users.inputs.username'"
            [maxlength]="50"
          ></app-input-general>
        </div>
      </div>
    </div>
  </div>

  <div class="flex justify-center items-center gap-4 px-4">
    <button
      mat-button
      [disabled]="!username.valid"
      (click)="recoverPassword()"
      class="button-general text-center w-auto! h-12.75 mt-2"
    >
      {{ 'users.button.recoverPassword' | translate }}
    </button>
  </div>

  <app-load-general [load]="isLoading"></app-load-general>
</div>
